import { combineReducers } from "redux";
import navigation from './Navigation';
import page from './Page';
import news from './News';


export default combineReducers({
	navigation,
	page,
	news
});


// WEBPACK FOOTER //
// ./src/js/reducers/RootReducer.js